import { render, staticRenderFns } from "./TabsProduct.vue?vue&type=template&id=381af878"
import script from "./TabsProduct.vue?vue&type=script&lang=js"
export * from "./TabsProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports